import React, { useState } from "react";

const servicesList = [
  "Website Development",
  "App Development",
  "Digital Marketing",
  "SEO Optimization",
  "UI/UX Design",
];

const Quote = () => {

  const [step, setStep] = useState(1);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    budget: "",
    message: "",
  });

  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const selectService = (service) => {
    setForm({ ...form, service });
  };

  const nextStep = () => {
    if (step === 1 && (!form.name || !form.email)) return;
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.service) return;

    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
      setStep(1);
      setForm({
        name: "",
        email: "",
        phone: "",
        service: "",
        budget: "",
        message: "",
      });
    }, 2500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-white to-gray-200 flex items-center justify-center p-6">

      <div className="w-full max-w-4xl bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200">


        <div className="relative h-[180px] flex items-center justify-center">

          <img
            src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg"
            className="absolute w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>

          <div className="relative text-center text-white">
            <h1 className="text-4xl font-bold tracking-wide">
              Request a Quote
            </h1>
            <p className="text-gray-200 mt-2">
              Step-by-step professional onboarding
            </p>
          </div>

        </div>

        <div className="px-10 pt-6">
          <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
            <div
              className="h-2 bg-gradient-to-r from-red-500 to-black rounded-full transition-all duration-500"
              style={{ width: step === 1 ? "33%" : step === 2 ? "66%" : "100%" }}
            ></div>
          </div>

          <p className="text-sm text-gray-500 mt-2">
            Step {step} of 3
          </p>
        </div>

        <div className="p-10">

          {step === 1 && (
            <div className="space-y-4">

              <h2 className="text-xl font-semibold text-gray-800">
                Basic Information
              </h2>

              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Full Name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-400 outline-none"
              />

              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email Address"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-400 outline-none"
              />

              <button
                onClick={nextStep}
                className="w-full bg-gradient-to-r from-black to-gray-800 text-white py-3 rounded-lg hover:scale-[1.02] transition"
              >
                Next →
              </button>

            </div>
          )}

          {step === 2 && (
            <div className="space-y-6">

              <h2 className="text-xl font-semibold text-gray-800">
                Choose Service
              </h2>

              <div className="flex flex-wrap gap-3">

                {servicesList.map((item, i) => (
                  <button
                    key={i}
                    type="button"
                    onClick={() => selectService(item)}
                    className={`px-4 py-2 rounded-full border transition-all duration-300 text-sm ${
                      form.service === item
                        ? "bg-gradient-to-r from-red-500 to-black text-white shadow-md scale-105"
                        : "bg-white text-gray-700 hover:border-black hover:scale-105"
                    }`}
                  >
                    {item}
                  </button>
                ))}

              </div>

              <div className="flex justify-between">

                <button onClick={prevStep} className="text-gray-500 hover:text-black">
                  ← Back
                </button>

                <button onClick={nextStep} className="bg-black text-white px-5 py-2 rounded-lg hover:bg-gray-800 transition">
                  Next →
                </button>

              </div>

            </div>
          )}

          {step === 3 && (
            <div className="space-y-4">

              <h2 className="text-xl font-semibold text-gray-800">
                Project Details
              </h2>

              <input
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-400 outline-none"
              />

              <input
                name="budget"
                value={form.budget}
                onChange={handleChange}
                placeholder="Budget (₹)"
                className="w-full p-3 border border-gray-300 rounded-lg"
              />

              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                rows="4"
                placeholder="Describe your project"
                className="w-full p-3 border border-gray-300 rounded-lg"
              />

              {success && (
                <div className="p-3 bg-green-100 text-green-700 rounded-lg animate-pulse">
                  🎉 Request submitted successfully
                </div>
              )}

              <div className="flex justify-between">

                <button onClick={prevStep} className="text-gray-500 hover:text-black">
                  ← Back
                </button>

                <button
                  onClick={handleSubmit}
                  className="bg-gradient-to-r from-black to-gray-800 text-white px-5 py-2 rounded-lg hover:scale-105 transition"
                >
                  Submit →
                </button>

              </div>

            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default Quote;